import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppConstants } from '../../../../appConstants';
import { ResponseDataBase } from '../../../../interfaces/responsedatabase.interface';
import { ResourceService, UserService } from '../../../../services/index.service';
import { PortalConfigurationService } from '../../../../services/portal-configuration/portal-configuration.service';
declare var $: any; // TODO show modal in othe way

@Component({
  selector: 'pin-generator-page',
  templateUrl: './pin-generator.page.html'
})
export class PinGeneratorPage implements OnInit {

  patnr = "";
  pin = "";
  patient = {
    name: '',
    lastname: '',
    email: ''
  }

  constructor(public _resourceService: ResourceService, public _portalConfigurationService: PortalConfigurationService,
    public _userService: UserService, public translate: TranslateService,) { }

  openModal() {
    this.clearAlerts();
    this._resourceService.loading = true;
    let params = {
      patnr: this.patnr
    };
    this._userService.getpatientpin(params).subscribe(data => {
      this._resourceService.loading = false;
      let response = data as ResponseDataBase;
      // response.result[0].email = "test@test.es";
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.patient = response.result[0];
        $('#pinGeneratorModal').modal('show');
        /* if (!this.patient.email) {
          this._resourceService.alert = "USER_WITHOUT_MAIL_PLEASE_ADD_IT_IN_ECH"
        } else {
          $('#pinGeneratorModal').modal('show');
        } */
      } else {
        this.translate.get(response.METADATA.ERROR_MESSAGE).subscribe(
          translation => {
            if (response.result) {
              this._resourceService.alert = translation + ": " + response.result[0].email
            } else {
              this._resourceService.alert = translation;
            }
          });
      }
      this._userService.loading = false;
    });
  }

  closeModal() {
    $('#pinGeneratorModal').modal('hide');
    delete this.pin;
  }

  print() {
    var mywindow = window.open();

    mywindow.document.write(`
    <html>
    <head>
    <title> ${document.title} </title>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-eOJMYsd53ii+scO/bJGFsiCZc+5NDVN2yr8+0RDqr0Ql0h+rP48ckxlpbzKgwra6" crossorigin="anonymous">
    </head>
    <body>
    <img src=${this._portalConfigurationService.configuration.logoURL.name}
      class="d-inline-block align-top size-100" alt="Logo">
    <p>${document.getElementById("pin").innerHTML}
</p><small> Recuerde que este PIN es sólo válido durante 5 días</small>
    </body>
    </html>
    `);
    setTimeout(function () {
      mywindow.print();
      mywindow.close();
    }, 1000);
    return true;
  }

  clearAlerts() {
    delete this._resourceService.alert;
  }

  generatePin() {
    let params = {
      patnr: this.patnr
    };
    this._userService.generatePin(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.pin = response.result[0];
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        window.scrollTo(0, 0);
      }
      this._userService.loading = false;
    });

  }

  sendpasstorolewithoutpass(role) {
    let params = {
      portalRole: role
    };
    this._userService.sendpasstorolewithoutpass(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.pin = response.result[0];
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        window.scrollTo(0, 0);
      }
      this._userService.loading = false;
    });

  }

  ngOnInit(): void {
  }

}
